import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export async function onEnterApexGame(payload) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "apex",
  });

  return refs.trackEvent(ANALYTIC_EVENTS.APEX_START, payload);
}

export function onExitApexGame(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.APEX_END, payload);
}
